import React from 'react';
import Menu, { MenuGroup, MenuItem } from '../../../../../shared/components/Menu/Menu';

function WikiTableMenu({ anchorRef, editor, onClose, open }) {
  const run = (command) => {
    command();
    onClose();
  };

  return (
    <Menu anchorRef={anchorRef} open={open} onClose={onClose} className="wiki-table-menu">
      <MenuGroup label="Insérer">
        <MenuItem onClick={() => run(() => editor.chain().focus().insertTable({ rows: 3, cols: 3, withHeaderRow: true }).run())}>
          Insérer un tableau
        </MenuItem>
      </MenuGroup>
      <MenuGroup label="Lignes et colonnes">
        <MenuItem disabled={!editor?.can().addRowAfter()} onClick={() => run(() => editor.chain().focus().addRowAfter().run())}>
          Ajouter une ligne
        </MenuItem>
        <MenuItem disabled={!editor?.can().addColumnAfter()} onClick={() => run(() => editor.chain().focus().addColumnAfter().run())}>
          Ajouter une colonne
        </MenuItem>
        <MenuItem danger disabled={!editor?.can().deleteRow()} onClick={() => run(() => editor.chain().focus().deleteRow().run())}>
          Supprimer la ligne
        </MenuItem>
        <MenuItem danger disabled={!editor?.can().deleteColumn()} onClick={() => run(() => editor.chain().focus().deleteColumn().run())}>
          Supprimer la colonne
        </MenuItem>
      </MenuGroup>
      <MenuGroup label="Cellules">
        <MenuItem disabled={!editor?.can().mergeCells()} onClick={() => run(() => editor.chain().focus().mergeCells().run())}>
          Fusionner les cellules
        </MenuItem>
        <MenuItem disabled={!editor?.can().toggleHeaderRow()} onClick={() => run(() => editor.chain().focus().toggleHeaderRow().run())}>
          Activer/désactiver l'en-tête
        </MenuItem>
      </MenuGroup>
      <MenuGroup label="Tableau">
        <MenuItem danger disabled={!editor?.can().deleteTable()} onClick={() => run(() => editor.chain().focus().deleteTable().run())}>
          Supprimer le tableau
        </MenuItem>
      </MenuGroup>
    </Menu>
  );
}

export default WikiTableMenu;
